import { businessKey } from 'queryKeys';

export const BUSINESS_PARTNER = 'business-partner';
const businessPartnerQuery = businessKey.query(BUSINESS_PARTNER);

export const grids = businessPartnerQuery.grids();
export const grid = businessPartnerQuery.grid();

export const details = businessPartnerQuery.details();
export const model = businessPartnerQuery.exact();

export const mutations = businessPartnerQuery.mutations();

const MUTATION_ARCHIVE = 'archive';
const MUTATION_RESTORE = 'restore';
const MUTATION_MOVE_TO_TEST = 'moveToTest';
const MUTATION_EXPORT = 'export';

export const remove = mutations.delete();
export const create = mutations.create();
export const update = mutations.update();
export const archive = mutations.mutate(MUTATION_ARCHIVE);
export const restore = mutations.mutate(MUTATION_RESTORE);
export const moveToTest = mutations.mutate(MUTATION_MOVE_TO_TEST);
export const exportBPs = mutations.mutate(MUTATION_EXPORT);
